// EXTERNAL IMPORTS
import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import { TopBar, Logo, userMenu, sideMenu } from "@lifepay/rc-ui-toolkit";
import { Route } from "react-router-dom";

// ABSOLUTE PATH IMPORTS
import actions from "model/actions";
import selectors from "model/selectors";
import OktellControls from "components/controls/OktellControls";

// RELATIVE PATH IMPORTS
import styles from "./Nav.m.scss";


@connect(
  // mapStateToProps function - passes data from store's state.
  (state) => {
    return {
      username: selectors.user.username$$(state),
      loggedIn: selectors.user.loggedIn$$(state),
      oktellSync: selectors.clients.oktellSync$$(state),
      oktellSyncStateChanges: selectors.clients.oktellSyncStateChanges$$(state),
    };
  },
  {
    logOut: actions.user.logOut,
    toggleOktellSync: actions.clients.toggleOktellSync,
  }
)
@themr("app", styles)
export default class Nav extends Component {
  // declaring props passed to the component
  static propTypes = {
    theme: PropTypes.object,
    username: PropTypes.string,
    loggedIn: PropTypes.bool,
    logOut: PropTypes.func,
    oktellSync: PropTypes.bool,
    oktellSyncStateChanges: PropTypes.bool,
    toggleOktellSync: PropTypes.func,
  };

  // enable, if need to connect WS of OkTell
  isEnableOkTell = false;

  render() {
    const {
      theme,
      username,
      logOut,
      loggedIn,
      oktellSync,
      oktellSyncStateChanges,
      toggleOktellSync,
    } = this.props;
    return (
      <div className={theme.wrapper}>
        <TopBar>
          <div>
            <Route
              exact
              path="/client"
              render={() => <sideMenu.SideMenuToggle/>}
            />
            <Logo text="Processing Client" useRouter />
          </div>


          {loggedIn ? (
            <userMenu.UserMenuController>
              {({isOpen, close, toggle}) => {
                return (
                  <div>
                    {
                      this.isEnableOkTell ?
                        <OktellControls
                          canSync
                          isPingingForNewCalls={oktellSync}
                          isStateChanges={oktellSyncStateChanges}
                          toggleOktellPing={toggleOktellSync}
                        />
                        : null
                    }

                    <userMenu.UserMenu
                      isOpen={isOpen}
                      username={username}
                      close={close}
                    >
                      <userMenu.UserMenuItem onClick={logOut}>
                        {"Выход"}
                      </userMenu.UserMenuItem>
                    </userMenu.UserMenu>
                    <userMenu.UserMenuToggle
                      isOpen={isOpen}
                      username={username}
                      toggle={toggle}
                    />
                  </div>
                );
              }}
            </userMenu.UserMenuController>
          ) : null}
        </TopBar>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Nav/Nav.js